import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from '../abstractRequest';
import {FormBuilderEnums, MANUAL_DESCRIPTION} from '../../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class AlmaGeneralDigitization extends AbstractRequest {
    constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
    ){
        super();
        this.formFields = [
            {
                key: MANUAL_DESCRIPTION,
                name: MANUAL_DESCRIPTION,
                label: 'almaDigitizationOther.manualDescription',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'partial',
                name: 'partial',
                value: '',
                path: 'drop-downs/isPartial',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                populator:  {
                    func: this.itemsArrayPopulator.bind(this),
                    params:     {
                       byKey: 'field-name',
                       byValue:'field-values'
                    }
                }

            },
             {
                key: 'chapterArticleTitle',
                name: 'chapterArticleTitle',
                label: 'almaDigitization.chapterArticleTitle',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'partial', value: 'Yes' }


            },
             {
                key: 'chapterArticleAuthor',
                name: 'chapterArticleAuthor',
                label: 'almaDigitization.chapterArticleAuthor',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'partial', value: 'Yes' }
            },
             {
                key: 'startPage',
                name: 'startPage',
                label: 'almaDigitization.startPage',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'partial', value: 'Yes' },
                inputType:'number',
                validPattern: '[1-9]\\d*'
            },
              {
                key: 'endPage',
                name: 'endPage',
                label: 'almaDigitization.endPage',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'partial', value: 'Yes' },
                inputType:'number',
                validPattern: '[1-9]\\d*'
            },
            {
                key: 'fullChapter',
                name: 'fullChapter',
                value: '',
                existingPath: 'dummyPath',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                dependOn: {key : 'partial', value: 'Yes' },
                options:[
                    {
                        label: 'almaDigitization.fullChapter',
                        value:'N'
                    }
                ]

            },
            {
                key: 'comment',
                name: 'comment',
                label: 'almaDigitization.comment',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'notNeededAfter',
                name: 'notNeededAfter',
                label: 'almaDigitization.notNeededAfter',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                minDate: 'now',
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                populator:  {
                    params:     {
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'generalUseLabel',
                name: 'generalUseLabel',
                label: 'almaDigitization.generalUseLabel',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.INTERACTABLE_LABEL
            },{
                key: 'instCode',
                name: 'instCode',
                label: 'almaRequest.institutionCode',
                mandatory: true,
                valuePath: 'instCode',
                existingPath: 'instCode',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'callNumber',
                name: 'callNumber',
                label: 'almaRequestOther.callNumber',
                mandatory: true,
                valuePath: 'callNumber',
                existingPath: 'callNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'holdingKey',
                name: 'holdingKey',
                label: 'almaRequestOther.holdingKey',
                mandatory: true,
                valuePath: 'holdingKey',
                existingPath: 'holdingKey',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'digitizationType',
                name: 'digitizationType',
                label: 'almaRequestOther.digitizationType',
                mandatory: true,
                valuePath: 'digitizationType',
                existingPath: 'digitizationType',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'volume',
                name: 'volume',
                label: 'almaRequest.volume',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'volume',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'issue',
                name: 'issue',
                label: 'almaRequest.issue',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'issue',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'part',
                name: 'part',
                label: 'almaRequest.part',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'part',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'publicationDate',
                name: 'publicationDate',
                label: 'almaRequest.publicationDate',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'publicationDate',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'genericCheckBox',
                name: 'genericCheckBox',
                label: '',
                value: '',
                existingPath: 'dummyPath',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[
                    {
                        label: 'almaDigitization.genericCheckBox',
                        value:'N'
                    }
                ]
            },
            {
                key: 'copyrightDeclaration',
                name: 'copyrightDeclaration',
                label: '',
                headline: 'almaDigitization.copyright.sub_title',
                value: '',
                existingPath: 'dummyPath',
                mandatory: true,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[
                    {
                        label:'almaDigitization.copyright.message',
                        value:'N'
                    }
                ]
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/almaGeneralDigitization.ts